import styled from 'styled-components'

import Tooltip from '../Tooltip'

export const Container = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  > label {
    font-weight: normal;
  }

  & > div {
    position: relative;
  }

  input {
    flex: 1;
    background: transparent;
    border: 1px solid #c2cad8;
    padding-right: 30px;

    background: ${props => props.erro && '#FFCCCC'};
    border: ${props => props.erro && '1px solid #ff3366'} !important;
    &::placeholder {
      color: #666360;
    }
  }

  svg {
    margin-right: 16px;
  }
`

export const Error = styled(Tooltip)`
  height: 20px;
  width: fit-content;
  position: absolute;
  right: 5px;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
  svg {
    margin: 0;
  }

  span {
    width: max-content;
    background: #c53030;
    color: #fff;
    right: -10px;

    &::before {
      right: 5px;
      transform: translateX(-80%);
      border-color: #c53030 transparent;
    }
  }
`

export const SelectContainer = styled.div<{ erro?: boolean }>`
  border-radius: 10px;

  > label {
    font-weight: normal;
  }

  select {
    width: 100%;
    /* padding: 5px; */

    border: ${props => props.erro && '1px solid #ff3366'} !important;
    color: ${props => (props.erro ? '#555' : '#000')};
    background-color: ${props => props.erro && '#FFCCCC'};

    option:disabled {
      display: none;
    }
  }
`

export const TextAreaContainer = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  textarea {
    width: 100%;
    padding: 5px;

    background: ${props => props.erro && '#FFCCCC'};

    option:disabled {
      display: none;
    }
  }
`
export const DatePickerContainer = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  input {
    flex: 1;
    background: transparent;
    border: 1px solid #c2cad8;
    padding-right: 30px;

    background: ${props => props.erro && '#FFCCCC'};
    border: ${props => props.erro && '1px solid #ff3366'} !important;
    &::placeholder {
      color: #666360;
    }
  }
  & > div {
    position: relative;
  }

  .react-datepicker,
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-size: 12px;
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 7px;
  }
`
export const MaskedInput = styled.input``
